import React from 'react';

/**
 * Nike AI Search Icon (Variant B)
 * Combines search magnifying glass with Nike AI sparkle
 * Lazy-loaded - only for variant-B users
 * Replaces standard search icon to visually hint Nike AI is accessible through search
 *
 * Note: SVG is aria-hidden because parent IconButton has aria-label
 */
const NikeAISearchIcon = () => (
  <svg
    aria-hidden="true"
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 5C12.5709 5 14.4468 5.83935 15.8037 7.19629C17.1606 8.55323 18 10.4291 18 12.5C18 13.8799 17.6268 15.1746 16.9766 16.2861H16.9756C16.6114 16.9075 16.6935 17.6329 17.1484 18.0879L20.5303 21.4697L19.4697 22.5303L16.0879 19.1484C15.0969 18.1574 15.0119 16.6699 15.6816 15.5273C16.2011 14.6391 16.5 13.6058 16.5 12.5C16.5 10.8429 15.8292 9.34487 14.7422 8.25781C13.6551 7.17075 12.1571 6.5 10.5 6.5C8.84285 6.5 7.34487 7.17075 6.25781 8.25781C5.17075 9.34487 4.5 10.8429 4.5 12.5C4.5 14.1571 5.17075 15.6551 6.25781 16.7422C7.34487 17.8293 8.84285 18.5 10.5 18.5C11.6267 18.5 12.6785 18.1905 13.5771 17.6523L13.9619 18.2959L14.3477 18.9395C13.2223 19.6133 11.9053 20 10.5 20C8.42915 20 6.55323 19.1606 5.19629 17.8037C3.83935 16.4468 3 14.5709 3 12.5C3 10.4291 3.83935 8.55323 5.19629 7.19629C6.55323 5.83935 8.42915 5 10.5 5ZM19.75 0V0.571289C19.75 2.05062 20.9494 3.25 22.4287 3.25H23V4.75H22.4287C21.042 4.75 19.901 5.8038 19.7637 7.1543L19.75 7.42871V8H18.25V7.42871C18.25 5.94938 17.0506 4.75 15.5713 4.75H15V3.25H15.5713L15.8457 3.23633C17.1962 3.09898 18.25 1.95803 18.25 0.571289V0H19.75ZM19 2.95898C18.7171 3.36443 18.3644 3.71713 17.959 4C18.3647 4.28302 18.7171 4.63627 19 5.04199C19.2831 4.63605 19.636 4.2831 20.042 4C19.6363 3.71705 19.283 3.36465 19 2.95898Z"
      fill="var(--podium-cds-color-text-primary, #111111)"
    />
  </svg>
);

NikeAISearchIcon.displayName = 'NikeAISearchIcon';

export default NikeAISearchIcon;
